import { Directive, EventEmitter, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  AppConstants,
  ComponentScreenDetails,
  HeaderAction,
  IComponent,
  trendSettingsInfo
} from '@nibras/core';
import { HTMLElementType } from '@nibras/core/common';
import { BehaviorSubject } from 'rxjs';
import { BaseDestroyableComponent } from './base-destroyable-component';

export enum LoaderType {
  spinner = 1,
  content = 2,
  avatar = 3,
  spinnerSmall = 4,
  dotProgress = 5
}

@Directive()
export abstract class BaseComponent extends BaseDestroyableComponent implements OnChanges {
  public isLoading = false;
  public componentClassName: string = this.constructor.name;
  public loaderType: typeof LoaderType = LoaderType;

  @Output()
  public componentCreated = new EventEmitter<BaseComponent>();

  @Output()
  public componentRefreshing = new EventEmitter<void>();

  headerActionsList: BehaviorSubject<HeaderAction[]> = new BehaviorSubject([]);
  subHeading: BehaviorSubject<string> = new BehaviorSubject('');
  headerKeyActionCount = 2;
  isOnFullScreen = false;
  defaultHeaderActionsList: HeaderAction[] = [];

  constructor(private triggerHeaderAction = true) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.ConfigData && changes.ConfigData.firstChange) {
      this.setDefaultActionList(changes.ConfigData.currentValue);
      if (this.triggerHeaderAction) {
        this.setComponentHeaderActions();
      }
      this.componentCreated.emit(this);
    }
  }

  setDefaultActionList(ConfigData?: IComponent) {
    this.defaultHeaderActionsList = [];

    if (ConfigData?.ShowRefresh) {
      this.defaultHeaderActionsList.push({
        title: 'Refresh',
        icon: 'refresh',
        action: 'refresh',
        group: 'refresh',
        type: HTMLElementType.button,
        actionCallBack: this.onRefreshClick.bind(this)
      });
    }

    this.defaultHeaderActionsList.push({
      ...AppConstants.MAXIMIZE_HEADER_ACTION,
      isActive: this.isOnFullScreen
    });

    if (ConfigData) {
      this.defaultHeaderActionsList.push({
        ...AppConstants.SOP_VIEWER_BUTTON_ACTION,
        options: [
          { label: 'SOPFile', value: ConfigData.SOPFile },
          { label: 'SOPContent', value: ConfigData.SOPContent }
        ]
      });
    }
  }

  public onRefreshClick() {
    this.componentRefreshing.emit();
  }

  public setComponentHeaderActions() {
    this.headerActionsList.next([...this.defaultHeaderActionsList]);
    //This method to set compoennt header actions from component
  }

  protected setHeaderActions(headerActions: HeaderAction[], includeDefaultActions = true) {
    if (includeDefaultActions) {
      this.headerActionsList.next([...this.defaultHeaderActionsList, ...headerActions]);
    } else {
      this.headerActionsList.next(headerActions);
    }
    //This method to set compoennt header actions from component
  }

  public onComponentResized(componentScreenDetails: ComponentScreenDetails) {
    //DO NOT WRITE ANYTHING HERE. Write intended code in the derived class's onComponentResized function.
  }

  public onTrendSettingsChanged(settingsInfo: trendSettingsInfo) {
    //DO NOT WRITE ANYTHING HERE. Write intended code in the derived class's onComponentResized function.
  }

  public onSettingsReceived(settings: string, isSave?: boolean, isApplySetting?: boolean) {
    //DO NOT WRITE ANYTHING HERE. Write intended code in the derived class's onSettingsReceived function.
  }
}
